import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { LiaSpinnerSolid } from "react-icons/lia";

import blueKbcLogo from '../../../../assets/images/branding/blue-kbc-logo.png';
import ItemAddedToaster from '../../../toasterscomponents/checklistToasters/ItemAddedToaster';
import CreatedSuccesFullyToaster from '../../../toasterscomponents/shepacktoasters/CreatedSuccesFullyToaster';


import TemplateA from '../ToasterQATableAandB/QaTableA';
import TemplateB from '../ToasterQATableAandB/QATableB';

const ToasterQATemplateFill = ({ 
  isOpen, 
  onClose,
  
  selectedSubmissionId,

  selectedSheFileId,
  selectedSheFileName,
  selectedSheFileUserScore,
  selectedSheFileScore,
  templates,
  isLoading,
  selectedCompany,
  selectedCompanyName,
  selectedDepartmentName,
  selectedDepartment, 

  // Functions 
  onRefreshTemplates // Brings latest scores after any changes done.
}) => {

  const navigate = useNavigate();

  const manualTemplates = templates.filter(template => 
    template.submission_type === 'Manual' && template.template_reference === "Medical Certificate"
  );

  // ----------------- State Management -----------------

 

  const [showToaster, setShowToaster] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [fullScreenImage, setFullScreenImage] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');



  const user = JSON.parse(sessionStorage.getItem('user'));

  /*-----------------------------------------------------------------
                            Use Effects 
  ---------------------------------------------------------------*/

  useEffect(() => {
    const timers = Object.keys(showToaster).map(key => 
      showToaster[key] && setTimeout(() => setShowToaster(prev => ({ ...prev, [key]: false })), 3000)
    );
    return () => timers.forEach(timer => clearTimeout(timer));
  }, [showToaster]);



  /*----------------------------------------------------
                      Functions
  ------------------------------------------------------*/

  // ------------------ Functions Approve and Reject Toasters -  -----------------


 



  
/*---------------------- Functions Approve and Reject - Save and Reject -----------------------*/

// --------------------- Template Approve and Reject -------------------------------
  


  // Function Template Approve - Approve the consultant template submissions. 
  
// Function Template Approve - Approve the consultant template submissions. 

  
  if (!isOpen) return null;

 

 
 
 

  return (
    <div className="checklist-question-user-fill-in-checklist-main-container">
      <div className="template-question-fill-in-checklist-container">
        <div className="template-fill-in-elements-container">
          <div className="user-fill-in-back-button-time-container">
            <div className='user-fill-in-back-button-container'>
              <img src={blueKbcLogo} alt="white-kbc-logo" className="add-quesiton-side-menu-logo" />
              <button type="button" onClick={onClose} className="user-fill-in-back-button"> Back</button>
            </div>
          </div>
          
          <div className="Template-fill-in-header-main-container">
            <div className="compliance-tracker-consultant-fill-in-header-main-container">
              <div className="Template-fill-in-header-text-main-container">

                <div>
                  <h3>Compliance Tracker QA- <span className="secondary-color-paragraph"> Review Consultant Submissions </span> </h3>
                  <p>Review and manage completed template submissions that are prepared for the Quality Assurance (QA) process.</p>
                </div>

                <div>
                  <h2>SHE File: <span style={{ color: 'black' }}>{selectedSheFileName} </span></h2>
                </div>
              </div>
                
              <div>
                <div>
                  <p>Company <span className="secondary-color-paragraph">{selectedCompanyName} </span> , Department <span className="secondary-color-paragraph">{selectedDepartmentName}</span></p>
                </div>
                <h2>
                  <span className="secondary-color-paragraph">
                    SHE File Score : {selectedSheFileUserScore || 0} /{selectedSheFileScore}
                  </span>
                </h2>
              </div>
            </div>

            {/* Section A - Table */}
            <TemplateA
              templates={templates}
              isLoading={isLoading}
              selectedSubmissionId={selectedSubmissionId}
              onRefreshTemplates={onRefreshTemplates}
              showToaster={showToaster}
              setShowToaster={setShowToaster}
              setErrorMessage={setErrorMessage}
            />

            {/* Section B - Manual Uploads */}
            <TemplateB
              templates={templates}
              manualTemplates={manualTemplates}
              selectedSubmissionId={selectedSubmissionId}
              selectedCompany={selectedCompany}
              selectedCompanyName={selectedCompanyName}
              selectedDepartment={selectedDepartment}
              selectedDepartmentName={selectedDepartmentName}
              onRefreshTemplates={onRefreshTemplates}
              showToaster={showToaster}
              setShowToaster={setShowToaster}
              setErrorMessage={setErrorMessage}
            />
          </div>
        </div>
      </div>

      {/* Template Document Viewer Modal */}
      

     
      {/* Toaster Notifications */}
      {showToaster.questionSaved && <ItemAddedToaster item={'Question Saved'} />}
      {showToaster.categorySaved && <ItemAddedToaster item={'Category Saved'} />}

      {/* ----------------- Toasters - Approve and Reject */}
      

     

      {showSuccess && 
        <CreatedSuccesFullyToaster
          heading='SHE File Filled Successfully'
        />
      }
    </div>
  );
};

export default ToasterQATemplateFill;